import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import styles from "../../styles/Home.module.css";
import axios from 'axios';
// import logo from '../../assets/logo/logo.png';
import LoginDialog from './login'
import { useHistory } from "react-router-dom";
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import useToken from '../auth/useToken';
import { useDispatch, useSelector } from "react-redux";
import { getAgentProfile, clearAll } from "../../redux/modules/profileSlice";
import api from '../../libs/utils/axiosApiInstance'
const useStyles = makeStyles((theme) => ({

  root: {
    flexGrow: 1,
  },
  button: {
    // marginRight: theme.spacing(2),
    background: '#FDB738',
    "&:hover": {
      background: '#f9a100',
    },
    color: '#FFFFFF',
  },
  logo: {
    flexGrow: 1,
  },
  buttonLogin: {
    background: '#3364AF',
  },
  buttonLoginAdmin: {
    background: '#ff6a00',
    "&:hover": {
      background: '#dd5c00',
    }
  },
  font1: { "fontFamily": "Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif", "fontWeight": "bold", "color": "#3364af", "fontSize": "2.6rem" },
  font2: { "fontFamily": "Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif", "fontWeight": "bold", "color": "#8faadc", "fontSize": "2.6rem" }


}));

export default function Header(user) {
  const dispatch = useDispatch();
  const agent = useSelector((state) => state.profile)
  const classes = useStyles();
  const history = useHistory();
  const { token, setToken } = useToken();
  const [url, setUrl] = useState('');
  const [auth, setAuth] = React.useState();
  const [openPopup, setOpenPopup] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedValue, setSelectedValue] = React.useState(false);
  const open = Boolean(anchorEl);


  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleCloseDialog = (value) => {
    if (value) {
      setAuth(true);
    }
    setOpenPopup(false);
    setSelectedValue(value);
  };

  const handleChange = (event) => {

    let path = `/`;
    history.push(path);

    localStorage.clear();
    setAnchorEl(null);
    setAuth(false);
    dispatch(clearAll())
  };

  const routeChange = () => {
    let path = `/register`;
    history.push(path);
  }

  const linktoadmin = () => {
    window.open(url);
  }

  const routeProfile = () => {
    let path = `/profile`;
    history.push(path);
    setAnchorEl(null);
  }

  const checkAuth = () => {
    // dispatch(getAgentProfile())
    const requestNo = localStorage.getItem('requestNo')
    const token = localStorage.getItem('token')
    const check = requestNo && token ? true : false;
    setAuth(check);
  }

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const clickLogin = () => {
    setOpenPopup(true);
  }

  const googleAnalytic = async () => {
    await api.get(`/visit`);
  }

  const init = async () => {
    const response = await fetch("/resources/config.json");
    const results = await response.json();
    setUrl(results?.REACT_APP_ADMIN_URL);
  }

  useEffect(() => {
    googleAnalytic();
    checkAuth();
    init()
  }, []);

  // useEffect(() => {

  //   checkAuth();   
  // }, [auth]);

  return (
    <>

      <AppBar position="static" style={{
        backgroundColor: '#FFFFFF',
        color: '#FFFFFF',
        boxShadow: "0px 0px 0px 0px",
        padding: '0.5rem 0 0.5rem 0',
        marginBottom: '10px',

        // height: '100px'

      }}>

        <Toolbar style={{
          display: 'flex',
          flexWrap: 'warp'
        }}>
          <Grid container>
            <Grid item md={6} xs={12}>
              <div className={classes.logo}>
                <img className="img-fluid me-2" style={{
                  width: '5.5rem',
                  background: 'transparent'
                }} src='/Rice-Dept_Copy.png' alt="logo"></img>
                <label style={{
                  color: '#af890e',
                  fontWeight: 'bold',
                  fontSize: '1.8rem',

                }}>ระบบการผลิตและการกระจายเมล็ดพันธุ์ข้าว</label>
                {/* <div class="text-center fixed-top">

               <label  style={{
              color: 'red',
              padding: '20px',
              border: '2px solid red',
              background: '#ff000094',
              fontWeight: 'bold',
              fontSize: '30px',
              color: '#ffff',
              marginLeft: '20rem',

            }}>SERVER TEST</label>
               </div> */}

              </div>
            </Grid>
            <Grid item md={6} xs={12}>
              <div style={{ textAlign: "end" }}>

                {/* <img className="img-fluid" src='/banner_5.png' alt="logo" style={{
width: '440px',
height: 'auto'
}}></img> */}

                <label className={classes.font1}>S</label><label className={classes.font2}> mart</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> eed</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> tock</label>&nbsp;&nbsp;<label className={classes.font1}>S</label><label className={classes.font2}> ystem</label>


                <div className="d-flex" style={{
                  flexWrap: 'wrap',
                  gap: '10px 20px',
                  rowGap: '10px',
                  columnGap: '16px',
                  marginTop: '10px',
                  justifyContent: 'end'
                }}>

                  <Button variant="contained" color="primary" className={classes.button} onClick={routeChange}>สมัครตัวแทน</Button>
                  {!auth && (
                    <Button variant="contained" className={classes.button} color="primary" startIcon={<SupervisorAccountIcon>send</SupervisorAccountIcon>}
                      onClick={clickLogin}
                    >เข้าสู่ระบบตัวแทน</Button>
                  )}
                  <Button variant="contained" color="primary" className={classes.buttonLogin} onClick={linktoadmin} >เข้าสู่ระบบเจ้าหน้าที่</Button>

                  {auth && (
                    <div>

                      <IconButton style={{
                        padding: '0px'
                      }}
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="default"
                      >
                        <AccountCircle style={{ fontSize: '2rem' }} />
                      </IconButton>
                      <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                          vertical: 'top',
                          horizontal: 'right',
                        }}
                        open={open}
                        onClose={handleCloseMenu}
                      >
                        <MenuItem onClick={routeProfile}>Profile</MenuItem>
                        <MenuItem onClick={handleChange}>Logout</MenuItem>
                      </Menu>


                    </div>

                  )}
                </div>







              </div>
            </Grid>
          </Grid>








        </Toolbar>


      </AppBar>
      <LoginDialog
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        onClose={handleCloseDialog}
      >

      </LoginDialog>


    </>
  )
}




